/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ space: NonNullable<unknown> }} Audit_Details_Api_Space_Updated_DescInputs */



/**
* | output |
* | --- |
* | "The API space \"{space}\" was changed." |
*
* @param {Audit_Details_Api_Space_Updated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_api_space_updated_desc = /** @type {((inputs: Audit_Details_Api_Space_Updated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Api_Space_Updated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der API-Space "${i?.space}" wurde geändert.`)
	return /** @type {LocalizedString} */ (`The API space "${i?.space}" was changed.`)
});